import styles from './divider.module.scss';

export interface DividerProps {
  direction?: 'horizontal' | 'vertical';
  width?: '1' | '2';
}

export const Divider = ({
  direction = 'horizontal',
  width = '1',
}: DividerProps) => {
  const className = [
    styles.divider,
    direction === 'horizontal' ? styles.horizontal : styles.vertical,
    width === '2' ? styles.width2 : styles.width1,
  ].join(' ');

  return <hr className={className} aria-hidden="true" />;
};
